/**
 * Where a client owner opens an invitation. The secret goes in the URL FRAGMENT: browsers never send a fragment to any server, and the receiving page clears it from the address bar as soon
 * as it has read it, so the secret does not end up in a server log or in history.
 */
export function invitationLink(token: string): string {
  return `${window.location.origin}/settings/authorized-partners#invite=${encodeURIComponent(token)}`;
}
